import http from "../../http-common";


export default class ContactService {
    static createMessage(data) {
        return http.post("/contact/create", data);
    }


}